import type { RemoteControlAction } from "@/schemas"

/**
 * Finds the target element for a remote control action.
 */
function resolveElement(action: RemoteControlAction): Element | null {
  const x = action.position.x * window.innerWidth
  const y = action.position.y * window.innerHeight
  const el = document.elementFromPoint(x, y)
  if (el) return el
  return null
}

function dispatchScroll(action: RemoteControlAction & { type: "scroll" }) {
  if (action.scope === "window") {
    window.scrollTo({
      top: action.scrollTop,
      left: action.scrollLeft,
    })
    return
  }

  const el = resolveElement(action)
  if (el instanceof HTMLElement) {
    el.scrollTo({
      top: action.scrollTop,
      left: action.scrollLeft,
    })
  } else {
    console.warn("Remote control scroll target not found", action)
  }
}

/**
 * Dispatches a remote control action as synthetic DOM events on the real page.
 */
export function dispatchRemoteAction(action: RemoteControlAction) {
  switch (action.type) {
    case "scroll":
      dispatchScroll(action)
      break
  }
}
